import { UserApi, Configuration, User, HttpFile, MagicLink, MagicLinkResponse } from "hotdesk_typescript";

export class UserService {
    userApi: UserApi;

    constructor(apiConfig: Configuration) {
        this.userApi = new UserApi(apiConfig);
    }

    async updateUser(userId: number, user: User) {
        return await this.userApi.userUpdate(userId, user);
    }

    async updateUserImage(userId: number, file: File) {
        return await this.userApi.userImageUpdate(userId, file as HttpFile);
    }

    async getUserById(userId: number) {
        return await this.userApi.userRead_1(userId);
    }

    async generateMagicLink(email: string): Promise<MagicLinkResponse> {
        return await this.userApi.userGenerateMagicLink({ email } as MagicLink);
    }
}